import { SuperTableColumnType } from '@modeso/types__aumico-lib-notes-be';
import { SuperTableColumnBelongingYear } from '@modeso/types__aumico-lib-notes-be/dist/models/enums/super_table_column_belonging_year.enum';
import { SuperTableColumnWidth } from '@modeso/aumico-lib-notes-fe/enums/SuperTableColumnWidth.ebum';

export interface ISuperTableAddFreeColumnDialogResult {
    title: string;
    dataType: SuperTableColumnType;
    belongingYear: SuperTableColumnBelongingYear;
    columnWidth?: SuperTableColumnWidth;
}
